import { clomp } from 'clomp';

export const Container = clomp.div`
  border-b
  border-gray-200
  pb-2
  shadow
`;
